export default [{
  "login_label": "Enter",
  "back_label": "Back",
  "login_message": "Login to your account",
  "homepage_subtitle": "Login to your account",
  "homepage_title": "Welcome in Workhera",
  "credentialsLoginMessage_label": "Log in with by email",
  "ssoAuthMessage_label": "Log in with corporate credentials",
  "credentialsLogin_label": "Login",
  "ssoAuth_label": "SSO",
  "emailBox_label": "Email",
  "password_label": "Password",
  "ssoLogin_title": "Log in with corporate credentials",
  "ssoLogin_subtitle": "Enter your company email",
  "ssoLogin_label": "SSO",
  "login_error": "Wrong credential!",
  "missing_user_error": 'User does not exist!',
  "account_locked_error": 'User temporarily locked. Too many failed login attempts!',
  "access_not_enabled": "Access not enabled",
  "sso_login_error": "Please log in with corporate credentials",
  "generic_error": "ops! a problem has occurred.",
  "lineseparator": "Otherwise",
  "teamsDoLogin_label": "Click to enter",
  "teamsWaiting_message": "Waiting login process in popup",

  "forgotPsw_title": "Password restore",
  "forgotPsw_subtitle": "Insert your email. A message will be delivered to you containing all the instructions to reset your password",
  "forgotPsw_restore": "Restore",
  "login_forgottenPassword": "Password forgotten? Click here!",
  "forgotPsw_mail_error": "Invalid mail",
  "forgotPsw_SSO_error": "SSO password reset required",
  "forgotPsw_generic_error": "Something went wrong",
  "forgotPsw_success": "Success! Your reset mail should arrive shortly"
}]
